<template>
  <div class="date-range-dialog">
    <v-card>
      <v-card-title>
        범위 선택
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <!--
            <v-col>
              <v-text-field
                v-model="dateRange.startDate"
                :rules="notEmptyValidation"
                label="일자"
                readonly
                required/>
            </v-col>
            -->

            <!-- disabled -->
            <!--
            <v-col>
              <v-text-field
                v-model="dateRange.startTime"
                :rules="notEmptyValidation"
                label="시작시각"
                type="time"
              />
            </v-col>

            <v-col>
              <v-menu transition="scale-transition" max-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateRange.endDate"
                    :rules="notEmptyValidation"
                    label="종료일자"
                    readonly
                    v-on="on"
                    required/>
                </template>
                <v-date-picker v-model="dateRange.endDate" no-title scrollable :show-current="false"/>
              </v-menu>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dateRange.endTime"
                :rules="notEmptyValidation"
                label="종료시각"
                type="time"
              />
            </v-col>
            -->
          </v-row>

          <v-row align="center" justify="center">
              <v-date-picker v-model="dateRange.startDate" scrollable locale="ko-kr" :show-current="false"/>
          </v-row>

          <!-- disabled -->
          <!--
          <v-row justify="center">
            <v-btn text @click="subtractFromNow(30, 'minutes', '최근 30분')">최근 30분</v-btn>
            <v-btn text @click="subtractFromNow(60, 'minutes', '최근 1시간')">최근 1시간</v-btn>
            <v-btn text @click="subtractFromNow(240, 'minutes', '최근 4시간')">최근 4시간</v-btn>
            <v-btn text @click="subtractFromNow(720, 'minutes', '최근 12시간')">최근 12시간</v-btn>
            <v-btn text @click="subtractFromNow(1440, 'minutes', '최근 24시간')">최근 24시간</v-btn>
            <v-btn text @click="subtractFromNow(7, 'days', '최근 7일')">최근 7일</v-btn>
            <v-btn text @click="subtractFromNow(1, 'months', '최근 1개월')">최근 1개월</v-btn>
          </v-row>
          -->

          <v-row class="ma-5" justify="center">
            <v-btn text @click="setDateFromNow(0)">오늘</v-btn>
            <v-btn text @click="setDateFromNow(1)">어제</v-btn>
            <v-btn text @click="setDateFromNow(7)">7일 전</v-btn>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-container>
          <v-row justify="end">
            <v-btn text color="error" @click="setRange">확인</v-btn>
            <v-btn text @click="dialog.dateRangeDialog = false">취소</v-btn>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'dateRangeDialog',
    props: {
      dialog: {
        type: Object,
        required: true
      },
      dateRange: {
        type: Object,
        require: true
      },
      selectedSiteStatus: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        notEmptyValidation: [
          value => !!value || '필수 값입니다'
        ],
      }
    },
    methods: {
      setRange() {
        // disabled
        //this.dateRange.rangeText = `${this.dateRange.startDate} ${this.dateRange.startTime} ~ ${this.dateRange.endDate} ${this.dateRange.endTime}`;

        this.dateRange.rangeText = this.dateRange.startDate;
        this.dateRange.startTime = '00:00:00';
        this.dateRange.endDate = this.dateRange.startDate;
        this.dateRange.endTime = '23:59:59';

        this.refreshGraphs();
        this.dialog.dateRangeDialog = false;
      },
      setDateFromNow(amountDate) {
        const now = moment();
        const startMoment = now.subtract(amountDate, 'days');
        this.dateRange.startDate = startMoment.format('YYYY-MM-DD');
        this.setRange();
      },
      subtractFromNow(amount, unit, rangeText, noRefresh) {
        this.dateRange.autoRefreshFunc = this.subtractFromNow.bind(this, amount, unit, rangeText, noRefresh);

        const now = moment();
        // 현재시간보다 뒤쪽을 endTime으로 지정한다.
        // 백쪽에서 endTimestamp를 확인하고 캐시를 사용할지 여부를 결정할 수 있게 하기 위해서이다.
        now.add(10, 'minutes');
        this.dateRange.endDate = now.format('YYYY-MM-DD');
        this.dateRange.endTime = now.format('HH:mm:ss');
        now.subtract(10, 'minutes');

        // 이 때 now값 자체도 변해버리는듯하니 주의(그러니까 사실은 startMoment로 받지 않아도 된다)
        const startMoment = now.subtract(amount, unit);
        this.dateRange.startDate = startMoment.format('YYYY-MM-DD');
        this.dateRange.startTime = startMoment.format('HH:mm:ss');

        if (rangeText) {
          this.dateRange.rangeText = rangeText;
        }

        this.dialog.dateRangeDialog = false;

        if (!noRefresh) {
          this.refreshGraphs();
        }
      },
      printDebugLog(target) {
        console.dir(target);
      },
      popupAlert(message, color) {
        this.$bus.$emit('popupAlert', {message: message, color: color});
      },
      refreshGraphs() {
        this.$bus.$emit('refreshGraphs');
      }
    }
  }
</script>